import React, { useEffect, useCallback } from 'react';
import useAnimationStore from '../../../../../common/store/useAnimationStore';

const useAnimation = (refs: React.RefObject<HTMLSpanElement>[]) => {
  const timeline = useAnimationStore(useCallback(state => state.landing.somersby.title, []));

  useEffect(() => {
    const doms: HTMLSpanElement[] = [];
    refs.forEach(ref => ref.current && doms.push(ref.current));

    timeline.to([doms], {
      duration: 1.5,
      ease: "back.out",
      y: "0%",
      opacity: 1,
      stagger: 0.1
    });

    return () => { timeline.clear() }
  }, []);
}

export default useAnimation;